import axios from 'axios'

const API_URL = process.env.VUE_APP_API_SUPPORT_URL

class TutorialService {
  getTutorialList() {
    return axios.get(API_URL + '/tutorial/published')
  }
  
  getFilteredTutorials (categoryId, searchText ) {
    searchText = searchText === '' ? 'null' : searchText
    categoryId = categoryId === '' ? 0 : categoryId
    return axios.get(API_URL + '/tutorial/published?categoryId=' + categoryId + '&searchText=' + searchText)
  }

  getTutorialDetailsbyId(Id) {
    return axios.get(API_URL + '/tutorial/' + Id)
  }
}

export default new TutorialService()
